import session from "@/api/ccSession";

export default {

  fetchCreditControl(account_id){
    return session.get(`/accounts/${account_id}/`);
  },

  updateQuickNote(account_id,note){
    return session.patch(`/accounts/${account_id}/`, {quick_note: note});
  },

  updateAccount(account_id,data){
    return session.patch(`/accounts/${account_id}/`, data);
  },

  recoverFromHandedOver(account_id){
    return session.post(`/accounts/${account_id}/actions/recover-from-handed-over/`);
  },

  fetchCreditControlHistory(account_id, config) {
    return session.get(`/logs/?customer_id=${account_id}&page=${config.paginationPage}&page_size=${config.paginationLimit}`);
  },

  fetchUddHistory(account_id, config) {
    return session.get(`/logs/?customer_id=${account_id}&attribute_changed=last_dd_failed_reason&current_state__ne=None&page=${config.paginationPage}&page_size=${config.paginationLimit}`);
  },

  saveExclusion(account_id, payload) {
    return session.patch(`/accounts/${account_id}/`, payload)
  },

  recoverFromDead01Udd(account_id) {
    return session.post(`/accounts/${account_id}/actions/recover-from-dead-01-udd/`);
  }
};
